// src/pages/Services.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';
import Widgets from '../components/WidgetTiles';

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Our Services | Redemption Psychiatry</title>
      </Helmet>
      <div className="wrap">
        <Header />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div id="content" role="main" className="home">

            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
              <div className="container">
                <h1>Our Services</h1>
              </div>
            </div>

            {/* Services Introduction */}
            <div id="services-introduction-container" className="container">
              <div>
                <div>
                  <LazyLoadImage alt="Placeholder" effect="blur" src="/img/our-services.png" />
                </div>
                <div>
                  <h2>Compassionate Care. Cutting-Edge Treatments. Life-Changing Results.</h2>
                  <p>
                    At Redemption Psychiatry, we believe in personalized, physician-led mental healthcare.
                    Our innovative treatments are designed to help you reclaim your life, whether you're struggling
                    with depression, anxiety, ADHD, or other mental health challenges.
                  </p>
                </div>
              </div>
            </div>

            {/* Services Cards */}
            <div id="services-cards-container" className="container">
              <p className="large">
                We combine the latest scientific breakthroughs with a deep commitment to patient care—because you deserve treatment that truly works for you.
              </p>
              <div>
                <div>
                  <div>
                    <h3>Medication Management</h3>
                    <p>Personalized prescriptions tailored to your unique needs</p>
                    <a href="/med-management" className="button blue">Learn More</a>
                  </div>
                </div>
                <div>
                  <div>
                    <h3>TMS Therapy</h3>
                    <p>Drug-free depression treatment with long-lasting results</p>
                    <a href="/tms" className="button blue">Learn More</a>
                  </div>
                </div>
                <div>
                  <div>
                    <h3>Ketamine Treatments</h3>
                    <p>Rapid relief for severe depression & anxiety</p>
                    <a href="/ketamine" className="button blue">Learn More</a>
                  </div>
                </div>
                <div>
                  <div>
                    <h3>ADHD Testing</h3>
                    <p>Comprehensive, science-backed evaluations for accurate diagnosis</p>
                    <a href="/adhd-testing" className="button blue">Learn More</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonials Section (reused) */}
            <Testimonials />

            {/* Widgets Section (reused) */}
            <Widgets />

          </div> {/* End #content */}
          <div className="push"></div>
        </motion.div>
        <Footer />
      </div>
    </>
  );
};

export default Services;
